import cn from 'classnames';
import { FC, ReactNode } from 'react';

import { ArrowDownIcon, ArrowUpIcon, Button } from '@catawiki/cata-style';

import styles from './AccordionItemTitle.module.scss';

interface AccordionItemTitleProps {
  children?: ReactNode;
  onToggle: () => void;
  open: boolean;
}

export const AccordionItemTitle: FC<AccordionItemTitleProps> = ({
  children,
  open,
  onToggle,
}) => (
  <header
    className={cn('u-p-xl', 'u-p-h-sm-m', styles.header, styles.specificity)}
  >
    <Button
      icon={open ? ArrowUpIcon : ArrowDownIcon}
      iconPosition="end"
      iconSize="s"
      color="black"
      iconColor="brand"
      iconSpacing="m"
      width="full"
      variant="tertiary"
      iconClassName={styles.icon}
      className={cn(styles.button)}
      contentClassName={cn(
        'tw:items-center tw:w-full tw:justify-between',
        styles.buttonContent,
        styles.question
      )}
      onClick={() => {
        onToggle();
      }}
    >
      {children}
    </Button>
  </header>
);
